// src/pages/SafetyStandardsPage.js

import React from 'react';
import './SafetyStandardsPage.css';

const SafetyStandardsPage = () => {
  return (
    <div className="policy-page">
      <header className="policy-header">
        <h1>Community & Safety Standards</h1>
      </header>
      
      <div className="policy-container">
        <section className="policy-block">
          <h2>1. Zero Tolerance for CSAE</h2>
          <p>RoomEase explicitly prohibits Child Sexual Abuse and Exploitation (CSAE). We do not tolerate any content, activities, or behavior that involves, harms, or exploits minors. Any account found to be involved in such activities will be permanently banned and reported to relevant authorities.</p>
        </section>

        <section className="policy-block">
          <h2>2. Reporting Mechanism</h2>
          <p>Your safety is our priority. Users can report inappropriate content or behavior directly through the in-app "Report" button located in the chat or on user profiles. All reports are reviewed by our safety team.</p>
        </section>

        <section className="policy-block">
          <h2>3. Addressing CSAM</h2>
          <p>Upon receiving a report of potential Child Sexual Abuse Material (CSAM), we follow a strict internal protocol to investigate, remove the content, ban the user, and report the incident to relevant law enforcement agencies as required by law.</p>
        </section>

        <section className="policy-block">
          <h2>4. Safety Point of Contact</h2>
          <p>For urgent safety-related inquiries, concerns, or to report CSAM, please contact our dedicated safety team:</p>
          <div className="contact-info">
            <p><strong>Safety Officer:</strong> Kushagra Arora</p>
            <p><strong>Email:</strong> <a href="mailto:support@roomease.co.in">support@roomease.co.in</a></p>
            <p><strong>Phone:</strong> <a href="tel:+919569994536">+919569994536</a></p>
          </div>
        </section>
        
        <section className="policy-date">
           <p><em>Effective Date: May 2, 2026</em></p>
        </section>
      </div>
    </div>
  );
};

export default SafetyStandardsPage;